import React from "react"
import "twin.macro"

function MaxWidthContainer({ children }) {
  return <div tw="container mx-auto">{children}</div>
}

export default MaxWidthContainer
